import { Component, Input } from '@angular/core';
import { ICompany } from '../../../../core/models/ICompany';
import { IUser } from '../../../../core/models/IUser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommentService } from '../../../../core/services/comment.service';
import { UserService } from '../../../../core/services/user.service';
import { LogService } from '../../../../core/services/log.service';

@Component({
  selector: 'app-comment-list',
  imports: [CommonModule,FormsModule],
  templateUrl: './comment-list.html',
  styleUrl: './comment-list.scss'
})
export class CommentList {
  @Input() company! : ICompany;
  currentUser : IUser | null = null;

  editingComment: any = null;  // le commentaire en cours d'édition

  constructor(
    private commentService: CommentService,
    private userService: UserService,
    private logger: LogService
  ) {
    this.currentUser = this.userService.currentUser;
  }

  ngOnInit(): void {
    this.commentService.getComments(this.company._id).subscribe({
      next: (data) => {
        this.company!.comments = data;
      },
      error : (err) => {
        this.logger.error('Erreur de chargement des commentaires: ' + JSON.stringify(err));
      }
    })
  }

  
  // activer l'édition d'un commentaire
  editComment(comment: any) {
    // copie pour éviter de modifier directement avant sauvegarde
    this.editingComment = { ...comment };
  }

  // sauvegarder le commentaire modifié
  saveComment() {
    if (!this.editingComment || !this.editingComment._id) return;

    this.commentService.updateComment(this.editingComment._id, this.editingComment.message).subscribe({
        next: (updatedComment) => {
          // mettre à jour le commentaire dans company.comments
          const index = this.company!.comments.findIndex(c => c._id === updatedComment._id);
          if (index > -1) {
            this.company!.comments[index] = updatedComment;
          }
          console.log("************")
          console.log(this.editingComment)
          this.editingComment = null; // fermer l'édition
          console.log(this.company?.comments)
          console.log(this.currentUser)
          console.log("************")

        },
        error: (err) => {
          this.logger.error("Erreur lors de la mise à jour du commentaire: " + JSON.stringify(err));
        }
      });
  }

  deleteComment(commentId: string){
      this.commentService.deleteComment(commentId).subscribe({
        next: () => {
          // On retire le comment localement
          this.company!.comments = this.company!.comments.filter(c => c._id !== commentId);
          this.editingComment = null; // fermer l'édition
        },
        error: (err) => {
          this.logger.error("Erreur lors de la suppression du commentaire: " + JSON.stringify(err));
        }
      });
  }

  // annuler l'édition
  cancelEdit() {
    this.editingComment = null;
  }

}
